import { Outlet } from 'react-router';
import Toolbar from '@layouts/toolbar/Toolbar';
import Footer from '@layouts/footer/Footer';



const MessageLayout = () => {

	return (
		<div className="lfmt-message-app">

			<Toolbar />
			
			<Outlet />

			<Footer />

		</div>
	);
};

export default MessageLayout;